module.exports = __webpack_public_path__ + "img/MixingValve.77167e2e.png";